import { WHATSAPP_SUBSCRIPTION } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { CommunicationSubscriptionDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import once from 'transmute/once';
import { DSFieldRecord } from '../../../public/core';
import I18n from 'I18n';
import { COMMUNICATION_SUBSCRIPTION } from '../../objectSeg/ObjectSegFilterTypes';
export default once(() => DSFieldRecord({
  displayType: CommunicationSubscriptionDisplayType,
  label: I18n.text(`customerDataFiltersUI.fieldNames.${WHATSAPP_SUBSCRIPTION}`),
  name: WHATSAPP_SUBSCRIPTION,
  type: COMMUNICATION_SUBSCRIPTION,
  referencedObjectType: WHATSAPP_SUBSCRIPTION
}));